(function () {
  const root = document.querySelector('[data-mbpf-root]');
  if (!root) return;

  const endpoint = root.dataset.endpoint || 'https://haendler.cannaselection.net/api/public/mbp-feedback';
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') || '';
  const stateEl = root.querySelector('[data-mbpf-state]');
  const form = root.querySelector('[data-mbpf-form]');
  const success = root.querySelector('[data-mbpf-success]');
  const errorBox = root.querySelector('[data-mbpf-error]');
  const appliedFields = root.querySelector('[data-applied-fields]');
  const tokenInput = root.querySelector('[data-mbpf-token]');
  const effectsInput = root.querySelector('[data-observed-effects-json]');
  const uploadInput = root.querySelector('[name="feedback_images"]');
  const preview = root.querySelector('[data-upload-preview]');
  const submit = root.querySelector('.mbpf-submit');
  const selectedFiles = [];
  const allowedTypes = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif']);
  const maxFileSize = 20 * 1024 * 1024;

  function setError(message) {
    if (!errorBox) return;
    errorBox.textContent = message || '';
    errorBox.hidden = !message;
  }

  function setFormInteractive(interactive) {
    if (!form) return;
    form.hidden = !interactive;
    form.setAttribute('aria-hidden', interactive ? 'false' : 'true');
    if ('inert' in form) form.inert = !interactive;
    form.querySelectorAll('input, select, textarea, button').forEach(field => {
      field.disabled = !interactive;
    });
    if (!interactive) {
      root.querySelectorAll('[data-status-panel]').forEach(panel => {
        panel.hidden = true;
      });
      if (appliedFields) appliedFields.hidden = true;
    }
  }

  function showState(title, message) {
    if (!stateEl) return;
    stateEl.hidden = false;
    stateEl.innerHTML = `<h2>${title}</h2><p>${message}</p>`;
    setFormInteractive(false);
    if (success) success.hidden = true;
    setError('');
  }

  function showForm(firstName) {
    if (stateEl) stateEl.hidden = true;
    if (success) success.hidden = true;
    setFormInteractive(true);
    if (tokenInput) tokenInput.value = token;
    const headline = root.querySelector('.mbpf-side h1');
    if (headline && firstName) headline.textContent = `Wie lief dein MicroBio+ Test, ${firstName}?`;
    syncStatus();
  }

  function showSuccess(message) {
    if (stateEl) stateEl.hidden = true;
    setFormInteractive(false);
    if (success) {
      success.hidden = false;
      const p = success.querySelector('p');
      if (p && message) p.textContent = message;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function buildRatings() {
    root.querySelectorAll('[data-rating]').forEach(container => {
      if (container.dataset.built === '1') return;
      container.dataset.built = '1';
      container.classList.add('mbpf-rating');
      const name = container.dataset.rating;
      const allowUnknown = container.dataset.unknown === '1';
      const required = container.dataset.required === '1' ? 'required' : '';
      const options = document.createElement('div');
      options.className = 'mbpf-rating-options';
      [1, 2, 3, 4, 5].forEach(value => {
        options.insertAdjacentHTML('beforeend', `<label><input type="radio" name="${name}" value="${value}" ${required}>${value}</label>`);
      });
      if (allowUnknown) {
        options.insertAdjacentHTML('beforeend', `<label class="is-unknown"><input type="radio" name="${name}" value="unknown" ${required}>Kann ich nicht beurteilen</label>`);
      }
      container.appendChild(options);
    });
  }

  function renderFiles() {
    if (!preview) return;
    preview.innerHTML = '';
    selectedFiles.forEach(file => {
      const url = URL.createObjectURL(file);
      const img = document.createElement('img');
      img.src = url;
      img.alt = file.name;
      img.onload = () => URL.revokeObjectURL(url);
      preview.appendChild(img);
    });
  }

  function syncStatus() {
    const status = form?.querySelector('[name="feedback_status"]:checked')?.value || '';
    root.querySelectorAll('[data-status-panel]').forEach(panel => {
      panel.hidden = panel.dataset.statusPanel !== status;
    });
    if (appliedFields) appliedFields.hidden = status !== 'applied';
  }

  function validateFiles(files) {
    if (files.length > 3) throw new Error('Bitte lade maximal 3 Bilder hoch.');
    files.forEach(file => {
      if (!allowedTypes.has(file.type) && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) {
        throw new Error(`${file.name} hat ein nicht unterstütztes Format.`);
      }
      if (file.size > maxFileSize) throw new Error(`${file.name} ist größer als 20 MB.`);
    });
  }

  function collectEffects() {
    return [...root.querySelectorAll('[data-effects] input:checked')].map(input => input.value);
  }

  function validateBeforeSubmit(status) {
    if (!status) throw new Error('Bitte wähle aus, ob du MicroBio+ bereits angewendet hast.');
    if (status !== 'applied') return;
    if (selectedFiles.length < 1) throw new Error('Bitte lade mindestens ein Feedbackbild hoch.');
    if (!collectEffects().length) throw new Error('Bitte wähle mindestens einen wahrgenommenen Effekt aus.');
  }

  async function loadToken() {
    if (!token) {
      showState('Feedback-Link fehlt', 'Dieser Feedback-Link ist ungültig oder wurde bereits verwendet. Wenn du glaubst, dass das ein Fehler ist, melde dich bitte bei uns.');
      return;
    }
    try {
      const response = await fetch(`${endpoint}?token=${encodeURIComponent(token)}`, { headers: { Accept: 'application/json' } });
      const payload = await response.json().catch(() => ({}));
      if (payload.status === 'used') return showSuccess(payload.message);
      if (!response.ok || !payload.ok || payload.status !== 'ready') {
        showState('Feedback-Link ungültig', payload.message || 'Dieser Feedback-Link ist ungültig oder wurde bereits verwendet. Wenn du glaubst, dass das ein Fehler ist, melde dich bitte bei uns.');
        return;
      }
      showForm(payload.first_name || '');
    } catch (error) {
      showState('Feedback nicht verfügbar', 'Der Feedbackbogen konnte gerade nicht geladen werden. Bitte versuche es später erneut.');
    }
  }

  buildRatings();
  form?.addEventListener('change', event => {
    if (event.target?.name === 'feedback_status') syncStatus();
    if (event.target?.name === 'ugc_permission') {
      const named = form.querySelector('[name="ugc_permission"]:checked')?.value === 'named';
      const field = root.querySelector('[data-ugc-name]');
      if (field) field.hidden = !named;
    }
  });

  uploadInput?.addEventListener('change', () => {
    try {
      setError('');
      selectedFiles.splice(0, selectedFiles.length, ...Array.from(uploadInput.files || []));
      validateFiles(selectedFiles);
      renderFiles();
    } catch (error) {
      selectedFiles.splice(0, selectedFiles.length);
      uploadInput.value = '';
      renderFiles();
      setError(error.message);
    }
  });

  form?.addEventListener('submit', async event => {
    event.preventDefault();
    try {
      setError('');
      const status = form.querySelector('[name="feedback_status"]:checked')?.value || '';
      validateBeforeSubmit(status);
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Feedback wird gesendet ...';
      }
      const formData = new FormData(form);
      formData.set('token', token);
      formData.set('observed_effects', JSON.stringify(collectEffects()));
      formData.delete('feedback_images');
      selectedFiles.forEach(file => formData.append('feedback_images', file, file.name));
      const response = await fetch(`${endpoint}?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload.ok) throw new Error(payload.error || payload.message || 'Feedback konnte nicht gesendet werden.');
      showSuccess(payload.message);
    } catch (error) {
      setError(error.message);
      if (submit) {
        submit.disabled = false;
        submit.textContent = 'Feedback absenden';
      }
    }
  });

  loadToken();
})();
